<template>
	<div>
		<!-- control position options -->
		<customizer-section title="Control Location">
			<template v-slot:icon>
				<div class="option-icon icon-lift_type"/>
			</template>

			<div class="customizer-options">
				<ul class="product-option-list">
					<li v-for="option in $options.controlOptions[product.control_style]" :key="option.value">
						<div class="product-option" :class="{ 'is-selected': controls == option.value }" role="button" @click.prevent="setHeadrailControls(option.value)">
							<div class="option-image is-mount-option"><img :src="option.image"/></div>
							<div class="option-name">{{ option.text }}</div>
						</div>	
					</li>
				</ul>
			</div>
		</customizer-section>


		<!-- mount style position options -->
		<customizer-section title="Mount Type">
			<template v-slot:icon>
				<div class="option-icon icon-lift_type"/>
			</template>

			<div class="customizer-options">
				<ul class="product-option-list">
					<li v-for="option in mountOptions" :key="option.value">
						<div class="product-option" :class="{ 'is-selected': mountPos == option.value }" role="button" @click.prevent="updateCartItem({ mountPos: option.value })">
							<div class="option-image is-mount-option"><img :src="option.image"/></div>
							<div class="option-name">{{ option.text }}</div>
						</div>	
					</li>
				</ul>
			</div>
		</customizer-section>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import CustomizerSection from './CustomizerSection.vue';

import { controlOptions } from '../options';

export default {
	controlOptions,
	components: { CustomizerSection },	

	data() 
	{
		return {
			mountOptions: [
				{ text: 'Inside Mount', value: 'inside', image: '/images/inside-mount-icon.png' },
				{ text: 'Outside Mount', value: 'outside', image: '/images/outside-mount-icon.png' },
			],

			/*controlOptions: {
				standard: [
					{ text: 'Controls On Left', value: 'left', image: '/images/control-pos-left.png' },
					{ text: 'Controls On Right', value: 'right', image: '/images/control-pos-right.png' },
				],

				opera_roller: [
					{ text: 'Room Darkening LEFT / Screen RIGHT', value: 'room darkening left / screen right', image: '/images/control-pos-left.png' },
					{ text: 'Room darkening RIGHT / Screen LEFT', value: 'room darkening right / screen left', image: '/images/control-pos-right.png' },
				],

				opera_dual_zebra: [
					{ text: 'Room Darkening LEFT / Zebra RIGHT', value: 'room darkening left / zebra right', image: '/images/control-pos-left.png' },
					{ text: 'Room darkening RIGHT / Zebra LEFT', value: 'room darkening right / zebra left', image: '/images/control-pos-right.png' },
				],
			},*/
		}
	},

	computed: {
		...mapState({
			product: state => state.customizer.product,
			count: state => state.customizer.headrailNum,
			controls: state => state.customizer.headrailControls,
			sizes: state => state.customizer.headrailSizes,
			mountPos: state => state.customizer.cartItem.mountPos,
		}),

		controlPos: {
			get() { return this.controls; },
			set(val) { this.setHeadrailControls(val); },
		}
	},

	methods: {
		...mapMutations('customizer', ['updateCartItem', 'setHeadrailCount', 'setHeadrailControls', 'setHeadrailSize']),
	}
}
</script>